import { useNavigate } from "react-router-dom";

const RequisitionHeader = ({ title }) => {
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center px-4 mb-4 bg-white shadow rounded-lg h-[70px]">
      <h2 className="text-xl font-semibold text-gray-800">{title || "Requisitions"}</h2>
      <button
        onClick={() => navigate("/Requisitions/New")}
        className="bg-primary text-white px-4 py-2 rounded-lg hover:opacity-90 transition-opacity"
      >
        + New Requisition
      </button>
    </div>
  );
};

export default RequisitionHeader;
